import type { Translation } from "@/i18n/locales/types";

export const activity: Translation["activity"] = {
  title: "Activity",
  description: "Who used which certificate, where and when.",
  tabs: {
    signatures: "Signatures",
    navigation: "Browsing",
    admin: "Administration",
  },
  privacy:
    "This log is personal data of your employees: you must inform them. It is kept for {{days}} days.",
  privacyNoRetention:
    "This log is personal data of your employees: you must inform them.",
  export: {
    button: "Export",
    csv: "Export CSV",
    json: "Export JSON",
    loginsCsv: "Export logins (CSV)",
    loginsJson: "Export logins (JSON)",
    done: "Downloaded {{name}}",
    hint: "With this tab's filters (one year at most).",
  },
  filters: {
    user: "Person",
    allUsers: "Everyone",
    credential: "Certificate",
    allCredentials: "All certificates",
    host: "Site",
    allHosts: "All sites",
    path: "URL contains…",
    decision: "Result",
    allDecisions: "All results",
    purpose: "Use",
    allPurposes: "All uses",
    result: "Result",
    allResults: "All results",
    category: "Category",
    allCategories: "All categories",
    action: "Action",
    allActions: "All actions",
    actor: "Who",
    allActors: "Everyone",
    period: "Period",
  },
  columns: {
    time: "Time",
    user: "Person",
    request: "Address",
    result: "Result",
    credential: "Certificate",
    where: "Where",
    purpose: "Use",
    action: "Action",
    actor: "Who",
    target: "On",
  },
  empty: {
    navigation: "No browsing with cloud certificates in this period.",
    signatures: "No signatures in this period.",
    admin: "No administration actions in this period.",
  },
  loadMore: "Load more",
  openDetail: "See the details of {{what}}",
  detail: {
    loginTitle: "Login",
    navigationTitle: "Request",
    signatureTitle: "Signature",
    adminTitle: "Action",
    user: "Person",
    credential: "Certificate",
    rule: "Rule",
    ruleLabel: "{{policy}} · rule {{number}}",
    noRule: "None (denied by default)",
    device: "Mac",
    app: "App",
    status: "HTTP status",
    url: "URL",
    method: "Method",
    occurredAt: "When (per the Mac)",
    receivedAt: "Received",
    createdAt: "When",
    purpose: "Use",
    host: "Site",
    format: "Format",
    operation: "Operation",
    origin: "Web origin",
    algorithm: "Algorithm",
    fingerprint: "Fingerprint of the signed data (SHA-256)",
    latency: "Latency",
    latencyValue: "{{ms}} ms",
    reason: "Reason",
    result: "Result",
    category: "Category",
    action: "Action",
    actor: "Who",
    target: "On",
    ip: "IP",
    before: "Before",
    raw: "Raw before and after",
    changes: "Changes",
    field: "Field",
    after: "After",
    details: "Data",
    nothing: "—",
    notLoaded:
      "This event is not in the loaded results. Change the filters or load more.",
  },
  createRule: {
    title: "Create a rule for this path",
    description:
      "Opens the policy editor with a rule already filled in with this path (escaped as an expression) and the tester loaded with this URL.",
    deny: "Deny this path",
    allow: "Allow this path",
  },
  seePolicy: "See the policy",
  categories: {
    admin: "Administration",
    access: "Sign-ins",
    support: "Support",
    system: "System",
  },
  actorTypes: {
    system: "System",
    app: "Mac app",
    support: "Punto support",
    platform_admin: "Platform",
  },
  reasons: {
    policy_denied: "Denied by the policy",
    credential_suspended: "Certificate suspended",
    no_valid_version: "No valid version",
    membership_suspended: "Person suspended",
    signature_limit_exceeded: "Signature limit exceeded",
    unsupported_algorithm: "Unsupported algorithm",
    key_backend_error: "KMS failure",
    login_sin_host: "Login without host with a «*» permission",
  },
  actions: {
    auth_login: "Signed in",
    auth_logout: "Signed out",
    policy_created: "Created a policy",
    policy_updated: "Changed a policy",
    policy_deleted: "Deleted a policy",
    credential_created: "Added a certificate",
    credential_updated: "Changed a certificate",
    credential_suspended: "Suspended a certificate",
    credential_reactivated: "Reactivated a certificate",
    credential_version_created: "Uploaded a version",
    credential_version_activated: "Activated a version",
    credential_version_scheduled: "Scheduled a version",
    credential_version_retired: "Retired a version",
    credential_version_rolled_back: "Went back to a previous version",
    user_invited: "Invited a person",
    user_role_changed: "Changed a role",
    user_removed: "Removed a person",
    user_suspended: "Suspended a person",
    user_reactivated: "Reactivated a person",
    group_created: "Created a group",
    group_updated: "Changed a group",
    group_deleted: "Deleted a group",
    group_members_added: "Added members to a group",
    group_member_removed: "Removed someone from a group",
    organization_updated: "Changed the organization",
    support_granted: "Granted support access",
    support_revoked: "Revoked support access",
    retention_purged: "Deleted expired data (retention)",
    audit_exported: "Exported the log",
    app_session_revoked: "Closed an app session",
  },
  actionGroups: {
    auth: "Sign-ins and sign-outs",
    policy: "Policies",
    credential: "Certificates",
    user: "People",
    group: "Groups",
    organization: "Organization",
    support: "Support",
    retention: "Retention",
    audit: "Exports",
  },
  targetTypes: {
    policy: "Policy",
    user: "Person",
    credential: "Certificate",
    credential_version: "Certificate version",
    group: "Group",
    organization: "Organization",
    support_grant: "Support access",
  },
  results: {
    success: "Success",
    failure: "Failure",
    denied: "Denied",
  },
  you: "You",
};
